import React from "react";
import { Icon } from "@jsq/ds/core";
import { ErrorMessageWrapper } from "./styles_vanilla.css";

export const ErrorMessage = () => (
  <div className={ErrorMessageWrapper}>
    <Icon type="exclamation-circle" size="medium" />
    Something went wrong! Please contact support if your problem persists.
  </div>
);
